import { useState, useMemo, useEffect } from 'react';
import { aplicarOrdenamiento } from './formatters';
import useBorradoProgreso from './useBorradoProgreso';

export const useLicenciasBorradoData = ({ token, showErrorToast }) => {
    // Estados de datos y selección
    const [candidatasTotal, setCandidatasTotal] = useState([]);
    const [licenciasSeleccionadas, setLicenciasSeleccionadas] = useState([]);
    const [cargando, setCargando] = useState(false);
    const [resumen, setResumen] = useState({});
    const [busqueda, setBusqueda] = useState('');
    const [conteoTabs, setConteoTabs] = useState({ 0: 0, 1: 0, 2: 0, 3: 0 });

    // Paginación y filtros
    const [mesesVencimiento, setMesesVencimiento] = useState(3);
    const [tipoLicencia, setTipoLicencia] = useState('Todos');
    const [ordenDias, setOrdenDias] = useState('DIAS_DESC');
    const [pagina, setPagina] = useState(1);
    const [tamanioPagina, setTamanioPagina] = useState(15);
    const [estatusBorrado, setEstatusBorrado] = useState(0);

    const { iniciarPollingProgreso } = useBorradoProgreso();

    // Cargar datos desde la API
    const cargarDatosServidor = async (meses, pag, tam, tipo, orden, estatus = null) => {
        setCargando(true);
        const valTipo = tipo !== undefined ? tipo : tipoLicencia;
        const valOrden = orden !== undefined ? orden : ordenDias;
        const valEstatus = estatus !== null ? estatus : estatusBorrado;

        setLicenciasSeleccionadas([]);

        try {
            if (valEstatus >= 1) {
                let iEstatusParam = 0;
                if (valEstatus === 2) iEstatusParam = 2;
                else if (valEstatus === 3) iEstatusParam = 1;

                const response = await fetch(`/api/Mantenimiento/ObtenerEmpresasPendientesBorrado?iEstatusBorrado=${iEstatusParam}`, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + token }
                });

                if (response.ok) {
                    const data = await response.json();
                    const dataTable = data.table3 || [];
                    const statsTable = data.table2 || [];

                    let listadoRaw = Array.isArray(dataTable) ? dataTable : [];

                    let mappedData = listadoRaw.map(d => {
                        let tipoLic = 'Desconocido';
                        if (d.TipoLicencia) {
                            tipoLic = d.TipoLicencia;
                        } else if (d.idCatTipoLicencia !== undefined && d.idCatTipoLicencia !== null) {
                            const idTipo = String(d.idCatTipoLicencia);
                            tipoLic = idTipo === '3' ? 'Nube' : (idTipo === '2' ? 'AkasiaPOS' : 'Desconocido');
                        }

                        const fechaProg = d.FechaProgramacion || d.FechaAgregada || d.FechaAgregadam || null;
                        const fechaActualizada = d.FechaActualizada || d.fechaActualizada || null;

                        return {
                            idLicencia: d.idLicencia || d.IdProgramacion || d.idProgramacion || 0,
                            idProgramacion: d.IdProgramacion || d.idProgramacion || 0,
                            vNombreEmpresa: d.NombreEmpresa || d.nombreEmpresa || 'Sin Nombre',
                            vUUIDEmpresa: d.UUIDEmpresa || d.uuidEmpresa,
                            vTipoLicencia: tipoLic,
                            iDiasVencidos: d.DiasVencidos !== undefined ? d.DiasVencidos : (d.diasVencidos || 0),
                            vServer: d.Servidor || d.servidor,
                            vDatabase: d.BaseDatos || d.baseDatos,
                            dFechaVencimiento: d.FechaVencimiento || d.fechaVencimiento,
                            dFechaProgramacion: fechaProg,
                            dFechaBorrado: d.FechaBorrado || d.fechaBorrado || null,
                            dFechaActualizada: fechaActualizada,
                            bTieneLicenciaVigente: d.bTieneLicenciaVigente === true || d.bTieneLicenciaVigente === 1 || String(d.bTieneLicenciaVigente) === '1',
                            vServerVigente: d.vServerVigente || d.serverVigente || null,
                            vDatabaseVigente: d.vDatabaseVigente || d.databaseVigente || null,
                            vTipoLicenciaVigente: d.vTipoLicenciaVigente || d.tipoLicenciaVigente || null,
                            dFinLicenciaVigente: d.dFinLicenciaVigente || d.fechaVencimientoVigente || null,
                            vMotivo: d.Motivo || d.motivo || null
                        };
                    });

                    if (valEstatus === 2) {
                        // No borradas: los últimos errores hasta arriba
                        mappedData.sort((a, b) => {
                            const timeA = new Date(a.dFechaActualizada || a.dFechaProgramacion || 0).getTime();
                            const timeB = new Date(b.dFechaActualizada || b.dFechaProgramacion || 0).getTime();
                            if (timeB !== timeA) return timeB - timeA;
                            return (b.idProgramacion || 0) - (a.idProgramacion || 0);
                        });
                        setCandidatasTotal(mappedData);
                    } else if (valEstatus === 1) {
                        // Programadas: las últimas programadas hasta arriba
                        mappedData.sort((a, b) => {
                            const timeA = new Date(a.dFechaProgramacion || 0).getTime();
                            const timeB = new Date(b.dFechaProgramacion || 0).getTime();
                            if (timeB !== timeA) return timeB - timeA;
                            return (b.idProgramacion || 0) - (a.idProgramacion || 0);
                        });
                        setCandidatasTotal(mappedData);
                    } else if (valEstatus === 3) {
                        // Borradas: las últimas borradas hasta arriba
                        mappedData.sort((a, b) => {
                            const timeA = new Date(a.dFechaBorrado || 0).getTime();
                            const timeB = new Date(b.dFechaBorrado || 0).getTime();
                            if (timeB !== timeA) return timeB - timeA;
                            return (b.idProgramacion || 0) - (a.idProgramacion || 0);
                        });
                        setCandidatasTotal(mappedData);
                    } else {
                        const listadoOrdenado = aplicarOrdenamiento(mappedData, valOrden);
                        setCandidatasTotal(listadoOrdenado);
                    }

                    if (statsTable && statsTable.length > 0) {
                        const s = statsTable[0];
                        setResumen(s);
                        setConteoTabs({
                            0: s.iTotalCandidatas || 0,
                            1: s.iTotalProgramadas || 0,
                            2: s.iTotalNoBorradas || 0,
                            3: s.iTotalBorradas || 0
                        });
                    }
                } else {
                    showErrorToast(`${response.status} ${response.statusText}`);
                }
            } else {
                const url = `/api/Mantenimiento/ObtenerLicenciasVencidasDataBorrado?iMesesVencimiento=${meses}&vTipoLicencia=${valTipo}&vOrden=${valOrden}&pagina=1&tamanioPagina=999999`;
                const response = await fetch(url, {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + token }
                });

                if (response.ok) {
                    const data = await response.json();
                    let detalles = {};
                    if (data && data.detalles && typeof data.detalles === 'string') {
                        try { detalles = JSON.parse(data.detalles); } catch (e) { detalles = {}; }
                    }

                    const t2 = detalles.table2 || data.table2;
                    const t3 = detalles.table3 || data.table3;
                    const listadoRaw = t3 || (t2 && (t2.length === 0 || t2[0].iTotalCandidatas === undefined) ? t2 : []) || [];

                    let listadoConVigentes = listadoRaw.map(d => ({
                        ...d,
                        bTieneLicenciaVigente: d.bTieneLicenciaVigente === true || d.bTieneLicenciaVigente === 1 || String(d.bTieneLicenciaVigente) === '1',
                        vServerVigente: d.vServerVigente || d.serverVigente || null,
                        vDatabaseVigente: d.vDatabaseVigente || d.databaseVigente || null,
                        vTipoLicenciaVigente: d.vTipoLicenciaVigente || d.tipoLicenciaVigente || null,
                        dFinLicenciaVigente: d.dFinLicenciaVigente || d.fechaVencimientoVigente || null
                    }));

                    const listadoOrdenado = aplicarOrdenamiento(listadoConVigentes, valOrden);
                    setCandidatasTotal(listadoOrdenado);

                    const resumenRow = (t2 && t2.length > 0 && t2[0].iTotalCandidatas !== undefined) ? t2[0] : null;
                    if (resumenRow) {
                        setResumen(resumenRow);
                        setConteoTabs(prev => ({
                            ...prev,
                            0: listadoOrdenado.length || resumenRow.iTotalCandidatas || 0,
                            1: resumenRow.iTotalProgramadas ?? prev[1],
                            2: resumenRow.iTotalNoBorradas ?? prev[2],
                            3: resumenRow.iTotalBorradas ?? prev[3]
                        }));
                    }
                } else {
                    showErrorToast(`${response.status} ${response.statusText}`);
                }
            }
        } catch (error) {
            showErrorToast('Error al conectar con el servidor: ' + error);
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        cargarDatosServidor(3, 1, 15, 'Todos', 'DIAS_DESC');

        // Validar una sola vez al cargar la lista si ya hay un proceso en ejecución
        const validarEjecucionActiva = async () => {
            try {
                const resp = await fetch('/api/Mantenimiento/ValidarProcesoEnEjecucion', {
                    method: 'GET',
                    headers: { 'Authorization': 'Bearer ' + token }
                });
                if (resp.ok) {
                    const data = await resp.json();
                    if (data.enEjecucion && Array.isArray(data.idsLicencias) && data.idsLicencias.length > 0) {
                        iniciarPollingProgreso(data.idsLicencias);
                    }
                }
            } catch (err) {
                console.error('Error al validar proceso en ejecución:', err);
            }
        };

        validarEjecucionActiva();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Recargar tabla automáticamente al terminar el borrado
    useEffect(() => {
        const handleBorradoTerminado = () => {
            cargarDatosServidor(mesesVencimiento, pagina, tamanioPagina, tipoLicencia, ordenDias, estatusBorrado);
        };

        window.addEventListener('akasia:mantenimiento:borrado_terminado', handleBorradoTerminado);
        return () => {
            window.removeEventListener('akasia:mantenimiento:borrado_terminado', handleBorradoTerminado);
        };
    }, [mesesVencimiento, pagina, tamanioPagina, tipoLicencia, ordenDias, estatusBorrado]);

    // Filtrado en cliente
    const itemsFiltrados = useMemo(() => {
        if (!busqueda || !busqueda.trim()) return candidatasTotal;
        const query = busqueda.trim().toLowerCase();
        return candidatasTotal.filter(d => {
            const nombre = (d.vNombreEmpresa || d.NombreEmpresa || '').toLowerCase();
            const uuid = (d.vUUIDEmpresa || d.UUIDEmpresa || '').toLowerCase();
            const idLic = String(d.idLicencia || d.IdProgramacion || '');
            const server = (d.vServer || d.Servidor || '').toLowerCase();
            const bd = (d.vDatabase || d.BaseDatos || '').toLowerCase();
            return nombre.includes(query) || uuid.includes(query) || idLic.includes(query) || server.includes(query) || bd.includes(query);
        });
    }, [candidatasTotal, busqueda]);

    const totalRegistros = itemsFiltrados.length;
    const totalPaginas = Math.ceil(totalRegistros / tamanioPagina) || 1;

    const candidatasPaginadas = useMemo(() => {
        const inicio = (pagina - 1) * tamanioPagina;
        return itemsFiltrados.slice(inicio, inicio + tamanioPagina);
    }, [itemsFiltrados, pagina, tamanioPagina]);

    // Helpers de selección
    const toggleSeleccion = (row) => {
        const existe = licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia);
        if (existe) {
            setLicenciasSeleccionadas(licenciasSeleccionadas.filter(l => l.idLicencia !== row.idLicencia));
        } else {
            setLicenciasSeleccionadas([...licenciasSeleccionadas, row]);
        }
    };

    const toggleSeleccionarTodo = (e) => {
        if (e.target.checked) {
            const nuevasSeleccionadas = [...licenciasSeleccionadas];
            candidatasPaginadas.forEach(row => {
                if (!nuevasSeleccionadas.find(l => l.idLicencia === row.idLicencia)) {
                    nuevasSeleccionadas.push(row);
                }
            });
            setLicenciasSeleccionadas(nuevasSeleccionadas);
        } else {
            const currentIds = candidatasPaginadas.map(row => row.idLicencia);
            setLicenciasSeleccionadas(licenciasSeleccionadas.filter(l => !currentIds.includes(l.idLicencia)));
        }
    };

    const todasSeleccionadasPaginaActual = candidatasPaginadas.length > 0 && 
        candidatasPaginadas.every(row => licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia));

    // Handlers de filtros y paginación
    const handleCambiarMeses = (e) => {
        const nuevosMeses = Number(e.target.value);
        setMesesVencimiento(nuevosMeses);
        setPagina(1);
        cargarDatosServidor(nuevosMeses, 1, tamanioPagina, tipoLicencia, ordenDias, estatusBorrado);
    };

    const handleCambiarTipoLicencia = (e) => {
        const nuevoTipo = e.target.value;
        setTipoLicencia(nuevoTipo);
        setPagina(1);
        cargarDatosServidor(mesesVencimiento, 1, tamanioPagina, nuevoTipo, ordenDias, estatusBorrado);
    };

    const handleCambiarEstatusBorrado = (estatus) => {
        setEstatusBorrado(estatus);
        setBusqueda('');
        setPagina(1);
        cargarDatosServidor(mesesVencimiento, 1, tamanioPagina, tipoLicencia, ordenDias, estatus);
    };

    const toggleOrdenColumna = () => {
        const siguienteOrden = ordenDias === 'DIAS_DESC' ? 'DIAS_ASC' : 'DIAS_DESC';
        setOrdenDias(siguienteOrden);
        setCandidatasTotal(prev => aplicarOrdenamiento(prev, siguienteOrden));
    };

    return {
        candidatasTotal,
        licenciasSeleccionadas,
        setLicenciasSeleccionadas,
        cargando,
        setCargando,
        resumen,
        busqueda,
        setBusqueda,
        conteoTabs,
        mesesVencimiento,
        tipoLicencia,
        ordenDias,
        pagina,
        setPagina,
        tamanioPagina,
        setTamanioPagina,
        estatusBorrado,
        cargarDatosServidor,
        itemsFiltrados,
        totalRegistros,
        totalPaginas,
        candidatasPaginadas,
        toggleSeleccion,
        toggleSeleccionarTodo,
        todasSeleccionadasPaginaActual,
        handleCambiarMeses,
        handleCambiarTipoLicencia,
        handleCambiarEstatusBorrado,
        toggleOrdenColumna
    };
};

export default useLicenciasBorradoData;
